import { FC } from 'react';
import { StyledArrowIcon, StyledContainer, StyledMessage } from './CallToAction.styles';
import { CallToActionProps } from './CallToAction.types';
import { Button } from '@/common/components';
import { Sizes } from '@/common/types';

const CallToAction: FC<CallToActionProps> = ({
  acctionButtonText,
  disabled = false,
  message,
  handleActionClick,
  testId = 'call-to-action',
}) => {
  return (
    <StyledContainer data-testid={testId}>
      <StyledMessage>{message}</StyledMessage>
      <Button disabled={disabled} onClick={handleActionClick} size={Sizes.MEDIUM}>
        {acctionButtonText}
        <StyledArrowIcon />
      </Button>
    </StyledContainer>
  );
};

export default CallToAction;
